import * as z from 'zod';

// Types
import { blocksSchemaZod } from '@/components/blocks/Blocks';
import { SeoZod } from '@/types/SeoType';

export const LandingZod = z.object({
  id: z.number(),
  documentId: z.string(),
  slug: z.string(),
  blocks: z.array(blocksSchemaZod),
  seo: SeoZod,
});

export type LandingType = z.infer<typeof LandingZod>;

export const LandingSlugZod = LandingZod.pick({
  id: true,
  documentId: true,
  slug: true,
  seo: true,
});

export type LandingSlugType = z.infer<typeof LandingSlugZod>;
